<template>
  <div class="prices relative" :class="{ 'min-h-32': loading }" aria-label="Cart">
    <loader v-if="loading"></loader>
    <quote-details :quote="quote"></quote-details>
  </div>
</template>
<script>
import { mapActions, mapState } from "pinia";
import useStore from "./../store"
import Loader from "./Loader";
import QuoteDetails from "./QuoteDetails";
// import {debounce} from "../helpers";

export default {
  components: {
    QuoteDetails,
    Loader,
  },
  props: {
    vouchers: {
      type: [Array, Boolean],
      default: false,
    },
    items: {
      type: Array,
      default: () => [],
    },
    participants: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      errors: [],
      total: 0,
      quote: {},
      loading: false,
      timer: null,
    };
  },
  computed: {
    ...mapState(useStore, ["totalPeople"]),

    discount() {
      if (this.quote?.items === null) {
        return false;
      }

      if (this.quote.totalPaid === 0) {
        return false;
      }

      return ` AUD -$${(this.quote.totalPaid).toFixed(2)}`;
    },

    hasTime() {
      return this.items.filter((a) => !!a.time).length === this.items.length;
    },
    hasParticipants() {
      return this.items.filter(function (a) {
        return Object.values(a.participants).reduce((total, value) => total + value, 0) > 0;
      }).length === this.items.length;
    },
  },
  methods: {
    // ...mapActions(useStore, ["quoteBooking"]),
    check() {
      console.log("Checking");

      if (!this.hasTime) {
        this.$emit("loading", false);
        return;
      }

      if (!this.hasParticipants) {
        this.$emit("loading", false);
        return;
      }

      this.errors = [];
      this.loading = true;

      useStore().quoteBooking()
        .then((response) => {
          this.quote = response;
        })
        .catch((error) => {
          if (error?.data?.requestStatus?.error?.errorMessage) {
            if (error?.data.requestStatus.error.errorMessage.includes("is not valid")) {
              this.errors.push(
                `Your coupon/voucher ${error.data.requestStatus.error.errorMessage.replace(
                  " is not valid",
                  ""
                )} isn't valid for the current order`
              );
            } else {
              this.errors.push(error.data?.requestStatus?.error?.errorMessage);
            }
          }

          if (error.data?.errors) {
            this.errors.push(error.data?.errors?.errorMessage);
          }

          this.loading = false;
        })
        .finally(() => {
          this.loading = false;

          this.$emit("errors", this.errors);
          this.$emit("loading", false);
        });
    },
    build() {
      if (this.totalPeople < 1) {
        return;
      }

      if (
        !this.gift &&
        this.items.filter((a) => !!a.time).length !== this.items.length
      ) {
        return;
      }

      // Declare a variable called 'timer' to store the timer ID
      let timer;
      const debounce = (mainFunction, delay) => {
        // Return an anonymous function that takes in any number of arguments
        return (...args) => {
          // Clear the previous timer to prevent the execution of 'mainFunction'
          clearTimeout(this.timer);

          // Set a new timer that will execute 'mainFunction' after the specified delay
          this.timer = setTimeout(() => {
            mainFunction(...args);
          }, delay);
        };
      }

      this.$nextTick(() => {});

      this.$emit('loading', true);

      console.log('Build....')

      debounce(() => this.check(), 1000)();
    },
  },
  watch: {
    items: {
      deep: true,
      handler() {
        this.build();
      },
    },
    participants: {
      deep: true,
      handler() {
        this.build();
      },
    },
    vouchers: {
      deep: true,
      handler() {
        this.build();
      },
    },
  },
};
</script>
